<template>
    <div id="searchTourscope" class="shadow">
        <load-area v-if="searchValues==null"></load-area>
        <Form method="dialog" v-slot="{ errors }" v-if="searchValues!=null" class="floating-labels" ref="form">
            <div class="top">
                <div class="floating-labels">
                    <div class="row">
                        <div class="col">
                            <datePicker v-model="dateRange" ref="datepicker" range :title="'Kalkış Tarih'" maxRange="31" :minDate="new Date()" :errors="errors" :rules="{required:true}"></datePicker>
                        </div>
                        <div class="col-lg-4">
                            <formGroup :title="'Günlük'" :as="'select'" v-model="model.Duration" :errors="errors">
                                <template #input>
                                    <option  v-for="item in days" :value="item.v" :key="item.v">{{item.n}}</option>
                                </template>
                            </formGroup>
                        </div>
                        <div class="col-lg">
                            <div class="form-group focused persons">
                                <input type="text" readonly class="form-control" :value="model.Adult+' Yetişkin' + (ChildCount>0?' - '+ChildCount+' Çocuk':'')" />
                                <label class="control-label">Yetişkin/Çocuk</label>
                                <div>
                                    <div>
                                        <div class="t">
                                            <strong class="box-title">Yetişkin</strong>
                                            <div>
                                                <div class="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                                                    <span class="input-group-btn input-group-prepend">
                                                        <button class="btn btn-secondary btn-outline bootstrap-touchspin-down" type="button" @click="model.Adult>1?model.Adult=model.Adult-1:null">-</button>
                                                    </span>
                                                    <input id="tch3" type="text" readonly v-model="model.Adult" name="adult" data-bts-button-down-class="btn btn-secondary btn-outline text-center" data-bts-button-up-class="btn btn-secondary btn-outline" class="form-control">
                                                    <span class="input-group-btn input-group-append">
                                                        <button class="btn btn-secondary btn-outline bootstrap-touchspin-up" type="button" @click="model.Adult==null?model.Adult=1:(model.Adult<8?model.Adult++:null)">+</button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="t">
                                            <strong class="box-title">Çocuk</strong>
                                            <div>
                                                <div class="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                                                    <span class="input-group-btn input-group-prepend">
                                                        <button class="btn btn-secondary btn-outline bootstrap-touchspin-down" type="button" @click="ChildCount>0?ChildCount=ChildCount-1:null;model.Childs.splice(ChildCount,1)">-</button>
                                                    </span>
                                                    <input id="tch3" type="text" readonly v-model="ChildCount" name="child" data-bts-button-down-class="btn btn-secondary btn-outline text-center" data-bts-button-up-class="btn btn-secondary btn-outline" class="form-control">
                                                    <span class="input-group-btn input-group-append">
                                                        <button class="btn btn-secondary btn-outline bootstrap-touchspin-up" type="button" @click="ChildCount==null?ChildCount=1:(ChildCount<3?ChildCount++:null);model.Childs.push(2)">+</button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <ul v-if="ChildCount>0">
                                            <li v-for="item,index in ChildCount" :key="item">
                                                <strong class="box-title">{{item}}. Çocuk Yaşı</strong>
                                                <div>
                                                    <select class="form-control" v-model.number="model.Childs[index]">
                                                        <option value="1">1 Yaş</option>
                                                        <option value="2">2 Yaş</option>
                                                        <option value="3">3 Yaş</option>
                                                        <option value="4">4 Yaş</option>
                                                        <option value="5">5 Yaş</option>
                                                        <option value="6">6 Yaş</option>
                                                        <option value="7">7 Yaş</option>
                                                        <option value="8">8 Yaş</option>
                                                        <option value="9">9 Yaş</option>
                                                        <option value="10">10 Yaş</option>
                                                        <option value="11">11 Yaş</option>
                                                        <option value="12">12 Yaş</option>
                                                        <option value="13">13 Yaş</option>
                                                        <option value="14">14 Yaş</option>
                                                        <option value="15">15 Yaş</option>
                                                        <option value="16">16 Yaş</option>
                                                        <option value="17">17 Yaş</option>
                                                    </select>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="toggle open">
                <div class="center">
                    <div class="row">
                        <div class="col">
                            <selectBox :title="'Ülke'" :as="'select'" v-model="model.DestinationCountryId" :errors="errors" :rules="{required:true}">
                                <template #search>
                                    <input type="text" placeholder="Ara..." class="form-control small" v-model="searchCountry">
                                </template>
                                <template #inputCustom>
                                    <template v-for="item in searchValues.Countries">
                                        <li :value="item.Id" :key="item.Id" v-if="item.Name.toLowerCase().indexOf(searchCountry.toLowerCase())>-1" :class="{'selected':model.DestinationCountryId==item.Id}" @click="model.DestinationCountryId=item.Id;model.DepartureCityId=null;$refs.form.validateField('Oparatör');">
                                            <span class="flag-icon" :class="'flag-icon-'+item.ISO2.toLowerCase()"></span>
                                            {{item.Name}}
                                        </li>
                                    </template>
                                </template>
                            </selectBox>
                        </div>
                        <div class="col">
                            <selectBox :title="'Kalkış Noktası'" :as="'select'" v-model="model.DepartureCityId" @change="model.Operators=[];$refs.form.validateField('Oparatör');" :errors="errors" :disabled="model.DestinationCountryId==null" :rules="{required:true}">
                                <template #search>
                                    <input type="text" placeholder="Ara..." class="form-control small" v-model="searchDeparture" :disabled="model.DestinationCountryId==null">
                                </template>
                                <template #input>
                                    <template v-for="country in searchValues.Countries">
                                        <template v-for="item in country.DepartureCities">
                                            <option :value="item.Id" :key="item.Id" v-if="model.DestinationCountryId!=null && model.DestinationCountryId==country.Id && item.Name.toLowerCase().indexOf(searchDeparture.toLowerCase())>-1">{{item.Name}}</option>
                                        </template> 
                                    </template>
                                </template>
                            </selectBox>
                        </div>
                        <div class="col">
                            <selectBox :title="'Oparatör'" :as="'select'" v-model="model.Operators" :errors="errors" :disabled="model.DepartureCityId==null" :rules="{required:true}">
                                <template #search>
                                    <input type="text" placeholder="Ara..." class="form-control small" v-model="searchOperator" :disabled="model.DepartureCityId==null">
                                </template>
                                <template #inputCustom>
                                    <template v-for="country in searchValues.Countries">
                                        <template v-for="departure in country.DepartureCities">
                                            <template v-for="item in departure.Operators">
                                                <li class="myCheckBox" :key="item.Id" v-if="model.DepartureCityId!=null && model.DepartureCityId==departure.Id && item.Name.toLowerCase().indexOf(searchOperator.toLowerCase())>-1">
                                                    <input type="checkbox" class="filled-in chk-col-teal" :checked="model.Operators.indexOf(item.Id)>-1">
                                                    <label @click="model.Operators.indexOf(item.Id)>-1?model.Operators=model.Operators.filter(x=>x!=item.Id):model.Operators.push(item.Id);$refs.form.validateField('Oparatör');">
                                                        {{item.Name}}
                                                    </label>
                                                </li>
                                            </template> 
                                        </template> 
                                    </template>
                                </template>
                            </selectBox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="action row align-items-center">   
                <div class="col tleft">
                    <div class="myCheckBox">
                        <input type="checkbox" class="filled-in" id="ToQueue" v-model="model.ToQueue"> 
                        <label for="ToQueue">ToQueue</label>
                    </div>
                </div>
                <div class="col-auto">
                    <Btn class="btn btn-warning waves-effect text-left" @click="search" :process="process"><span class="p-l-20 p-r-20">CreateListScanItems</span> </Btn>
                </div>
            </div>
        </Form>
    </div>
    <div class="card m-t-20" v-if="data!=null">
        <dataTable :name="'Countries'" ref="agGrid" :columnDefs="columnDefs" :data="data" @cellClicked="detail=$event.data"></dataTable>
    </div>
    <modal size="xl" v-if="detail!=null" @close="detail=null">
        <template #content>
            <ul class="nav nav-tabs profile-tab border-bottom">
                <li class="nav-item">
                    <a href="javascript:;" class="nav-link" :class="{'active':tab==1}" @click="tab=1">JSON</a>
                </li>
                <li class="nav-item">
                    <a href="javascript:;" class="nav-link" :class="{'active':tab==2}" @click="tab=2">Hotels</a>
                </li>
            </ul>
            <pre class="m-0" v-if="tab==1">{{getDetail}}</pre>
            <dataTable :name="'Countries'" v-if="tab==2" ref="agGrid" :columnDefs="detailColumnDefs" :data="detail.Hotels"></dataTable>
        </template>
    </modal>
</template>

<script>
    import moment from 'moment';
    import datePicker from "../../../components/formGroup/rangeDatePicker.vue"
    import selectBox from "../../../components/formGroup/selectBox.vue"
    export default {
        name:"Scans",
        components:{datePicker,selectBox},
        data(){
            return {
                searchValues:null,
                dateRange:[],
                searchCountry:"",
                searchDeparture:"",
                searchOperator:"",
                hotelSelect:false,
                days:[{n:'7',v:7},{n:'10',v:10},{n:'14',v:14}],
                model:{
                    DepartureCityId: null,
                    DestinationCountryId:null,
                    Duration: 7,
                    Adult: 2,
                    Childs: [],
                    StartDate: "",
                    EndDate: "",
                    Operators: [],
                    ToQueue:false
                },
                ChildCount:0,
                openReport:null,
                process:false,
                err:null,
                data:null,
                columnDefs:[
                    {"headerName":"Retry","field":"Retry","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"ReportKey","field":"ReportKey","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"ConnectionId","field":"ConnectionId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Operator","field":"Operator","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                        valueFormatter:function(params){
                            return params.value?.Name
                        }
                    },
                    {"headerName":"Duration","field":"Duration","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"StartDate","field":"StartDate","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                        valueFormatter:function(params){
                            return moment(new Date(params.value)).format('DD.MM.YYYY')
                        }
                    },
                    {"headerName":"EndDate","field":"EndDate","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                        valueFormatter:function(params){
                            return moment(new Date(params.value)).format('DD.MM.YYYY')
                        }
                    },
                    {"headerName":"DepartureCountry","field":"DepartureCountry","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                        valueFormatter:function(params){
                            return params.value?.Name
                        }
                    },
                    {"headerName":"DepartureCity","field":"DepartureCity","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                        valueFormatter:function(params){
                            return params.value?.Name
                        }
                    },
                    {"headerName":"DestinationCountry","field":"DestinationCountry","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                        valueFormatter:function(params){
                            return params.value?.Name
                        }
                    },
                    {"headerName":"DestinationPlace","field":"DestinationPlace","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                        valueFormatter:function(params){
                            return params.value?.Name
                        }
                    },
                    {"headerName":"Hotels","field":"Hotels","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                        valueFormatter:function(params){
                            return params.value.length
                        }
                    },
                    {"headerName":"Adult","field":"Adult","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Childs","field":"Childs","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Type","field":"Type","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"PriceKeys","field":"PriceKeys","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140}
                ],
                detail:null,
                tab:1,
                detailColumnDefs:[
                    {"headerName":"Id","field":"Id","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"OperatorId","field":"OperatorId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"CountryCode","field":"CountryCode","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"CountryId","field":"CountryId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Code1","field":"Code1","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Code2","field":"Code2","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Region","field":"Region","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"SubRegion","field":"SubRegion","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Name","field":"Name","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Star","field":"Star","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"RoomCount","field":"RoomCount","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Long","field":"Long","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"Lat","field":"Lat","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"HotelId","field":"HotelId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    {"headerName":"AddDate","field":"AddDate","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140}
                ]
            }
        },
        created(){
            this.dateRange.push(new Date());
            this.dateRange.push(new Date());
            this.dateRange[1].setDate(this.dateRange[1].getDate()+6);
            this.$appAxiosTourscope.get(`CompareHotelsItems/228`).then(response=>{
                this.searchValues=response.data;
            });
        },
        methods:{
            search(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        var startDate=new Date(this.dateRange[0]);
                        var endDate=new Date(this.dateRange[1]);
                        this.model.StartDate=startDate.getFullYear()+"-"+((startDate.getMonth()+1)<10?"0"+(startDate.getMonth()+1):startDate.getMonth()+1)+"-"+(startDate.getDate()<10?"0"+startDate.getDate():startDate.getDate());
                        this.model.EndDate=endDate.getFullYear()+"-"+((endDate.getMonth()+1)<10?"0"+(endDate.getMonth()+1):endDate.getMonth()+1)+"-"+(endDate.getDate()<10?"0"+endDate.getDate():endDate.getDate());
                        this.process=true;
                        this.err=null;
                        this.data=null;
                        this.$appAxiosTourscope.post(`Helpers/CreateListScanItems`,this.model).then(response=>{
                            this.data=response.data;
                            this.process=false;
                        }).catch(err=>{
                            this.err=err;
                            this.process=false;
                        });
                    }
                });
            }
        },
        computed:{
            getDetail(){
                var data={...this.detail};
                delete data.Hotels;
                return data;
            }
        }
    }
</script>

<style>

</style>